<template>
  <div :class="['desk-event', timeCssClass]">
    <div class="period">
      <div class="date">{{ startDate }}</div>
      <div class="time">{{ startTime }}</div>
      <div class="delimiter"></div>
      <div class="date" v-if="endDate">{{ endDate }}</div>
      <div class="time">{{ endTime }}</div>
    </div>
    <div class="event-body">
      <div class="user" v-if="employee">
        <app-avatar :src="employeeAvatarSrc" class="mr-2"></app-avatar>
        <div>
          <div>{{ employee.name }}</div>
          <div>{{ employee.email }}</div>
        </div>
      </div>
      <div class="actions d-flex">
        <!--        <a href="#" class="action-before" @click="expandToggle">{{ expanded ? 'collapse' : 'expand' }}</a>-->
        <a href="#" class="action-after" @click="addAfter">add another booking</a>
        <a href="#" class="action-edit ml-auto mr-2" @click="edit">edit</a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import AppAvatar from '@/components/shared/AppAvatar'
import { getAvatarSrc, isLeadingMonth } from '@/utils/Helpers'
import { SERVER_DATE_TIME_FORMAT } from '@/components/desk/utils'
import { getIconUrl } from '@/components/leaflet/Icon'
import { POINT_ICONS } from '@/store/modules/point'

export default {
  name: 'DeskEvent',
  components: { AppAvatar },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    expanded: false
  }),
  computed: {
    ...mapGetters('employee', ['getEmployee']),
    employee() {
      return this.getEmployee(this.event.employee_id)
    },
    iconSrc() {
      return getIconUrl(POINT_ICONS.EMPLOYEE)
    },
    employeeAvatarSrc() {
      return getAvatarSrc(this.employee.avatar_id, this.employee.avatar_updated_at, this.iconSrc)
    },
    start() {
      return dayjs(this.event.start, SERVER_DATE_TIME_FORMAT)
    },
    end() {
      return dayjs(this.event.end, SERVER_DATE_TIME_FORMAT)
    },
    localeMonthDayFormat() {
      return isLeadingMonth() ? 'MM/DD' : 'DD/MM'
    },
    startDate() {
      return this.start.format(this.localeMonthDayFormat)
    },
    startTime() {
      return this.start.format('HH:mm')
    },
    endDate() {
      if (this.start.isBefore(this.end, 'date')) {
        return this.end.format(this.localeMonthDayFormat)
      }
      return false
    },
    endTime() {
      return this.end.format('HH:mm')
    },
    isPast() {
      return this.end.isBefore(dayjs())
    },
    isPresent() {
      return !this.isPast && this.start.isBefore(dayjs())
    },
    timeCssClass() {
      if (this.isPast) return 'past'
      if (this.isPresent) return 'present'
      return 'future'
    }
  },
  methods: {
    expandToggle() {
      this.expanded = !this.expanded
    },
    addAfter() {
      this.$emit('addAfter')
    },
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style scoped lang="scss">
.desk-event {
  box-shadow: 1px 1px 7px #ccc;
  margin-bottom: 20px;
  padding: 6px 6px 6px 8px;
  display: flex;
  align-items: center;
  overflow: hidden;

  &.past {
    opacity: 0.6;
    & .action-after,
    & .action-before {
      display: none;
    }
  }

  &.present {
    border: 1px solid rgb(118, 118, 118);
    box-shadow: rgba(0, 0, 0, 0.33) 0 7px 11px;
  }
}

.period {
  border-right: 2px solid #ccc;
  padding-right: 12px;
  margin-right: 6px;

  .date {
    line-height: 24px;
    text-align: center;
    font-size: 20px;
    padding: 0 3px;
  }

  .time {
    text-align: center;
  }

  .delimiter {
    width: 8px;
    height: 1px;
    background: #ccc;
    margin: 2px auto;
  }
}

.event-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-width: 0;

  .user {
    display: flex;
    overflow: hidden;
    text-overflow: clip;
    margin: auto 0;
  }

  .actions {
    margin-top: auto;

    a {
      display: inline-block;
      white-space: nowrap;
      border-bottom: 1px dashed #1e70cd;
      margin-left: 8px;
      line-height: 14px;
    }
  }
}
</style>
